// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import CircularBar from 'react-multicolor-circular-progress-bar';
import styles from './semi-circle.module.scss';

// eslint-disable-next-line @nrwl/nx/enforce-module-boundaries
import {
  CcfThanksForLoyalityIcon,
  CcfActiveListeningIcon,
  CcfBeEmpatheticIcon,
  CcfBuildRapportIcon,
  CcfDemonstrateOwnerShipIcon,
  CcfAskQuestionIcon,
  CcfSetExpectationIcon,
  CcfNoInterruptionIcon,
  CcfIdentifySolutionIcon,
  CcfOverallSentimentSadIcon,
  CcfSpeechVelocityIcon,
  CcfEmpowerClientIcon,
  CcfOverallSentimentSmileIcon,
  CcfOverallSentimentMehIcon
} from '@nice-ccf/ui-controls';


/* eslint-disable-next-line */
export interface SemiCircleProps {}

/**
 * Component to display Semi circle for RTIG Score 
 * @param param0 - SemiCircleProps
 * @example <SemiCircle />
 * @returns
 */
export function SemiCircle(props: any) {
  const percentage = props.percentage ? props.percentage : 0;
  const label = props.label ? props.label : '';
  const showLabel = props.showLabel ? props.showLabel : false;
  const strokeWidth = props.strokeWidth ? props.strokeWidth : 8;
  const scale = props.scale ? props.scale : 0.6;
  const imageSrc = props.imageSrc ? props.imageSrc : '';

  /**
   * function  to render Icon For GuidancceScore
   * @param param0 - param
   * @example renderIconForGuidancceScore()
   * @returns
   */
  function renderIconForGuidancceScore(param: string) {
    switch (param) {
      case 'thank-for-loyalty':
        return <CcfThanksForLoyalityIcon className="guidance-score-icon" />;
      case 'active-listening':
        return <CcfActiveListeningIcon className="guidance-score-icon" />;
      case 'be-empathetic':
        return <CcfBeEmpatheticIcon className="guidance-score-icon" />;
      case 'build-rapport':
        return <CcfBuildRapportIcon className="guidance-score-icon" />;
      case 'demonstrate-ownership':
        return <CcfDemonstrateOwnerShipIcon className="guidance-score-icon" />;
      case 'ask-questions':
        return <CcfAskQuestionIcon className="guidance-score-icon" />;
      case 'set-expectations':
        return <CcfSetExpectationIcon className="guidance-score-icon" />;
      case 'no-interruptions':
        return <CcfNoInterruptionIcon className="guidance-score-icon" />;
      case 'identify-solution':
        return <CcfIdentifySolutionIcon className="guidance-score-icon" />;
      case 'empower-client':
        return <CcfEmpowerClientIcon className="guidance-score-icon" />;
      case 'speech-velocity':
        return <CcfSpeechVelocityIcon className="guidance-score-icon" />;
      /**
       * Below cases are used for overall sentiment which is shown in top section
       */
      case 'sad':
        return <CcfOverallSentimentSadIcon className="sentiment-icon" />;
      case 'meh':
        return <CcfOverallSentimentMehIcon className="sentiment-icon" />;
      case 'smile':
        return <CcfOverallSentimentSmileIcon className="sentiment-icon" />;
      default:
        return '';
    }
  }

  return (
    <div className={styles['semi-circle']}>
      <CircularBar
        id="semi-circle"
        scale={scale}
        fontFamily="roboto"
        gapGradient={10}
        angleTransition={[52, 125]}
        colors={['#ff2b53', '#ffba1f', '#36c700']}
        semiCircular={true}
        percent={{
          value: percentage,
          showValue: false,
          fontSize: 10,
          fontWeight: 'bold',
          color: '#4e4e4e',
          align: 'middle',
          position: {
            X: 0,
            Y: -4,
          },
        }}
        stroke={{
          color: '#eeeeee',
          width: strokeWidth,
        }}
      />
      {renderIconForGuidancceScore(imageSrc)}

      {showLabel && (
        <div className="dial-label">
          <span>{label}</span>
        </div>
      )}
    </div>
  );
}

export default SemiCircle;
